import {
  Component, OnInit, OnDestroy, AfterViewInit,
  HostListener, ChangeDetectionStrategy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserModuleService } from '../../services/user-module.service';
import { HttpClient } from '@angular/common/http';
import { ValidationHelper } from '../../shared/model/validationHelper';
import { passwordMatchValidator } from '../../shared/model/passwordMatchValidator';
import { Subscription, fromEvent, throttleTime } from 'rxjs';

export interface GridCell {
  type: 'win' | 'dark' | 'cg' | 'cy';
}

@Component({
  selector: 'app-sign-in',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInComponent implements OnInit, AfterViewInit, OnDestroy {
  isDark = true;

  currentScreen: 'login' | 'forgot' = 'login';

  forgotForm!: FormGroup;
  showPwd = false;
  loginForm!: FormGroup;
  submitted = false;
  togglePasswordIcon = false;
  isPasswordVisible = false;
  showPassword: boolean = false;
  loginBtnText = 'Sign in';
  isLoggingIn: boolean = false;

  addForm: FormGroup;
  receivedData: string = '';
  showPassword1: boolean = false;
  showPassword2: boolean = false;
  passwardMatch: boolean = false;

  private readonly LOCAL_SRC = 'https://kgablobprod.blob.core.windows.net/kgapublic/golf-video.mp4';
  private readonly FALLBACK_SRC = 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';
  private allVideos: HTMLVideoElement[] = [];
  private syncTimer!: ReturnType<typeof setInterval>;
  private watchdogTimer!: ReturnType<typeof setInterval>;
  private resizeObserver!: ResizeObserver;
  private subscription!: Subscription;

  @ViewChild('inputpassword') inputpassword!: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private userService: UserModuleService
  ) {
    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern(ValidationHelper.passwordPattern)]],
    });
    this.addForm = this.formBuilder.group({
      newpassword: ['', [Validators.required, Validators.pattern(ValidationHelper.passwordPattern)]],
      password: ['', [Validators.required, Validators.pattern(ValidationHelper.passwordPattern)]],
    }, {
      validators: [this.passwordMatchValidator]
    })
  }

  get f() {
    return this.loginForm.controls;
  }

  get g() { return this.addForm.controls };

  userLogin() {
    this.router.navigate(['/menu']);
  }

  togglePassword() {
    this.togglePasswordIcon = !this.togglePasswordIcon;
    this.inputpassword.nativeElement.setAttribute(
      'type',
      this.togglePasswordIcon ? 'text' : 'password'
    );
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }
    this.isLoggingIn = true;
    this.loginBtnText = 'Signing in...';
    this.userService.login(this.loginForm.value).subscribe({
      next: (resp) => {
        const userDetails = JSON.stringify(resp.body);
        localStorage.setItem('userDetails', userDetails);
        // localStorage.setItem('userId', resp.body?.adminUser);
        this.isLoggingIn = false;
        this.loginBtnText = 'Sign in';

        if (resp.status === 200) {
          let moduleListAcess = resp.body.modules;
          if (moduleListAcess.length == 0) {
            this.toastr.error('Please assign atleast one module to the user to signin.')
          } else if (moduleListAcess.length == 1) {
            let [result] = moduleListAcess;
            // console.log(result);     
            this.navigateApp(result, resp.body)
          } else {
            this.router.navigate(['/module']);
          }
        }
      },
      error: (error) => {
        console.error('Login failed:', error.error);
        if (error.error.StatusCode == 400) {
          const message = error?.error?.Message;
          this.toastr.error(
            message === 'User is Inactive.'
              ? message
              : message || 'Incorrect email or password. Please try again.'
          );
        }
        this.isLoggingIn = false;
        this.loginBtnText = 'Sign in';
      }
    });
  }

  navigateApp(module: any, userData: any) {
    let authorizationToken = userData?.sessionToken ? userData.sessionToken : "123";
    let id = userData?.adminUser.adminUserId;
    const url = `${module.moduleUrl}?token=${authorizationToken}&id=${id}&module=${module.moduleId}`;
    window.location.href = url
  }

  showResetPassword() {
    const emailControl = this.loginForm.get('email');

    if (!emailControl?.value) {
      emailControl?.markAsTouched();
      return;
    }

    this.currentScreen = 'forgot';
    this.addForm.reset();
    this.submitted = false;
    this.addForm.markAsUntouched();
  }

  ngOnInit() {
    // const button = document.getElementById('forgetButton');
    // if (button) {
    //   this.subscription = fromEvent(button, 'click')
    //     .pipe(throttleTime(10000)) // Allow click only once every 10s
    //     .subscribe(() => this.showResetPassword());
    // }

    //   this.toastr.success("Password Reset Successfully")
  }

  updatePassward() {
    this.submitted = true;

    if (this.addForm.valid) {
      let payload = {
        email: this.loginForm.value.email,
        newpassword: this.addForm.get('password')?.value
      }
      this.userService.updatePassward(payload).subscribe((resp) => {

        if (resp.status == 200) {
          this.toastr.success("Password Reset Successfully")
          this.currentScreen = 'login';
        }
      }, (error) => {
        console.error("Login failed:", error.error);
        this.toastr.error(error.error.Message)
      })
    }
    else {
      return;
    }
  }

  goBack(): void {
    this.currentScreen = 'login';
    this.loginForm.reset();
  }

  readonly cells: GridCell[] = [
    { type: 'win' }, { type: 'win' }, { type: 'win' }, { type: 'win' },
    { type: 'win' }, { type: 'win' }, { type: 'win' }, { type: 'win' },
    { type: 'win' }, { type: 'cg' }, { type: 'win' }, { type: 'win' },
    { type: 'win' }, { type: 'win' }, { type: 'cy' }, { type: 'win' },
  ];

  ngAfterViewInit(): void {
    this.probeAndInject();

    this.syncTimer = setInterval(() => this.syncAll(), 2000);

    this.watchdogTimer = setInterval(() => this.watchdog(), 5000);

    const mosaic = document.getElementById('mosaic');
    if (mosaic) {
      this.resizeObserver = new ResizeObserver(() =>
        requestAnimationFrame(() => this.alignVideos())
      );
      this.resizeObserver.observe(mosaic);
    }

    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    clearInterval(this.syncTimer);
    clearInterval(this.watchdogTimer);
    this.resizeObserver?.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.allVideos.forEach(v => { v.pause(); v.src = ''; v.load(); });
    this.allVideos = [];
  }

  toggleTheme(): void {
    this.isDark = !this.isDark;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.allVideos.forEach(v => { if (v.paused) v.play().catch(() => { }); });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    requestAnimationFrame(() => this.alignVideos());
  }

  private probeAndInject(): void {
    const probe = document.createElement('video');
    probe.preload = 'metadata';
    probe.src = this.LOCAL_SRC;
    let done = false;
    const go = (src: string) => { if (done) return; done = true; this.injectVideos(src); };
    probe.addEventListener('loadedmetadata', () => go(this.LOCAL_SRC));
    probe.addEventListener('error', () => go(this.FALLBACK_SRC));
    setTimeout(() => go(this.LOCAL_SRC), 1000);
  }

  private injectVideos(src: string): void {
    document.querySelectorAll<HTMLElement>('.c.win').forEach(cell => {
      if (cell.querySelector('video')) return;

      const v = document.createElement('video');
      v.src = src;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.preload = 'auto';
      v.style.cssText = 'position:absolute;pointer-events:none;display:block;object-fit:cover;';

      v.addEventListener('stalled', () => {
        v.load();
        v.play().catch(() => { });
      });
      v.addEventListener('suspend', () => {
        if (v.paused) v.play().catch(() => { });
      });
      v.addEventListener('waiting', () => {
      });
      v.addEventListener('error', () => {
        if (v.src !== this.FALLBACK_SRC) {
          v.src = this.FALLBACK_SRC;
          v.load();
          v.play().catch(() => { });
        }
      });

      cell.appendChild(v);
      this.allVideos.push(v);
      v.play().catch(() => { });
    });

    requestAnimationFrame(() => requestAnimationFrame(() => this.alignVideos()));
  }

  private alignVideos(): void {
    const mosaic = document.getElementById('mosaic');
    if (!mosaic) return;
    const mr = mosaic.getBoundingClientRect();

    document.querySelectorAll<HTMLElement>('.c.win').forEach(cell => {
      const v = cell.querySelector('video') as HTMLVideoElement | null;
      if (!v) return;
      const cr = cell.getBoundingClientRect();
      v.style.width = mr.width + 'px';
      v.style.height = mr.height + 'px';
      v.style.left = -(cr.left - mr.left) + 'px';
      v.style.top = -(cr.top - mr.top) + 'px';
    });
  }

  private syncAll(): void {
    if (this.allVideos.length < 2) return;
    const master = this.allVideos[0];
    const t = master.currentTime;
    this.allVideos.slice(1).forEach(v => {
      if (Math.abs(v.currentTime - t) > 0.12) v.currentTime = t;
    });
    this.allVideos.forEach(v => { if (v.paused && !v.ended) v.play().catch(() => { }); });
  }

  private lastTime = -1;
  private frozenCount = 0;

  private watchdog(): void {
    const master = this.allVideos[0];
    if (!master) return;
    if (master.paused) { master.play().catch(() => { }); this.frozenCount = 0; return; }
    if (Math.abs(master.currentTime - this.lastTime) < 0.05) {
      this.frozenCount++;
      if (this.frozenCount >= 2) {
        this.frozenCount = 0;
        const src = master.src;
        this.allVideos.forEach(v => { v.src = src; v.load(); v.play().catch(() => { }); });
        requestAnimationFrame(() => requestAnimationFrame(() => this.alignVideos()));
      }
    } else {
      this.frozenCount = 0;
    }
    this.lastTime = master.currentTime;
  }

  private readonly onVisibilityChange = (): void => {
    if (!document.hidden) {
      this.allVideos.forEach(v => { if (v.paused) v.play().catch(() => { }); });
    }
  };

  passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const newPassword = control.get('newpassword');
    const confirmPassword = control.get('password');

    if (!newPassword || !confirmPassword) {
      return null;
    }

    if (newPassword.value !== confirmPassword.value) {
      const error = { passwordMismatch: true };
      confirmPassword.setErrors({ ...confirmPassword.errors, ...error });
      return error;
    } else {
      const errors = confirmPassword.errors;
      if (errors) {
        delete errors['passwordMismatch'];
        confirmPassword.setErrors(Object.keys(errors).length ? errors : null);
      }
      return null;
    }
  };

  openCanarys(event: Event) {
    event.preventDefault();
    window.open('https://ecanarys.com/', '_blank');
  }
}